import { Union, Record } from "./fable_modules/fable-library.3.7.20/Types.js";
import { union_type, list_type, float64_type, option_type, bool_type, int32_type, record_type, string_type, class_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { FeeConfig$reflection } from "./GlobalTypes.js";
import { IsoCountryCode$reflection } from "./DomainTypes.js";
import { endsWith, substring } from "./fable_modules/fable-library.3.7.20/String.js";
import { custom } from "./fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { head } from "./fable_modules/fable-library.3.7.20/Array.js";
import { startImmediate } from "./fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "./fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { map, defaultArgWith } from "./fable_modules/fable-library.3.7.20/Option.js";
import { tryFind } from "./fable_modules/fable-library.3.7.20/Map.js";

export class ClientObjectCode extends Record {
    constructor(ClientObjectNr, ObjectDescription) {
        super();
        this.ClientObjectNr = ClientObjectNr;
        this.ObjectDescription = ObjectDescription;
    }
}

export function ClientObjectCode$reflection() {
    return record_type("Global.ClientObjectCode", [], ClientObjectCode, () => [["ClientObjectNr", class_type("System.Decimal")], ["ObjectDescription", string_type]]);
}

export class CustomerGroupCode extends Record {
    constructor(CustomerGroupCode, CustomerGroupName) {
        super();
        this.CustomerGroupCode = (CustomerGroupCode | 0);
        this.CustomerGroupName = CustomerGroupName;
    }
}

export function CustomerGroupCode$reflection() {
    return record_type("Global.CustomerGroupCode", [], CustomerGroupCode, () => [["CustomerGroupCode", int32_type], ["CustomerGroupName", string_type]]);
}

export class ClientUnpaidInvoiceReminderSetting extends Record {
    constructor(IncludeOnAutogiro, SMSTemplate, EmailSubjectTemplate, EmailBodyTemplate, ReminderDaysAfterDueDate) {
        super();
        this.IncludeOnAutogiro = IncludeOnAutogiro;
        this.SMSTemplate = SMSTemplate;
        this.EmailSubjectTemplate = EmailSubjectTemplate;
        this.EmailBodyTemplate = EmailBodyTemplate;
        this.ReminderDaysAfterDueDate = (ReminderDaysAfterDueDate | 0);
    }
}

export function ClientUnpaidInvoiceReminderSetting$reflection() {
    return record_type("Global.ClientUnpaidInvoiceReminderSetting", [], ClientUnpaidInvoiceReminderSetting, () => [["IncludeOnAutogiro", bool_type], ["SMSTemplate", string_type], ["EmailSubjectTemplate", string_type], ["EmailBodyTemplate", string_type], ["ReminderDaysAfterDueDate", int32_type]]);
}

export class ClientInvoiceFee extends Record {
    constructor(DistributionCode, DistributionCodeDesc, Description, IncludeFeeOnAutogiroVarsel, PriceExclVat, VatRatePercent, InvoiceeType, PriceInclVat, Kontonummer) {
        super();
        this.DistributionCode = DistributionCode;
        this.DistributionCodeDesc = DistributionCodeDesc;
        this.Description = Description;
        this.IncludeFeeOnAutogiroVarsel = IncludeFeeOnAutogiroVarsel;
        this.PriceExclVat = PriceExclVat;
        this.VatRatePercent = VatRatePercent;
        this.InvoiceeType = InvoiceeType;
        this.PriceInclVat = PriceInclVat;
        this.Kontonummer = (Kontonummer | 0);
    }
}

export function ClientInvoiceFee$reflection() {
    return record_type("Global.ClientInvoiceFee", [], ClientInvoiceFee, () => [["DistributionCode", option_type(int32_type)], ["DistributionCodeDesc", string_type], ["Description", string_type], ["IncludeFeeOnAutogiroVarsel", bool_type], ["PriceExclVat", float64_type], ["VatRatePercent", float64_type], ["InvoiceeType", option_type(int32_type)], ["PriceInclVat", option_type(float64_type)], ["Kontonummer", int32_type]]);
}

export class ClientConfig extends Record {
    constructor(HasCustomerGroupCode, UsesSubscriptionObjectCode, UsesCreditCheck, ShowInvoiceeAttributes, ShowContractAttributes, ClientInvoiceFees, DefaultInvoiceExclVat, MortgageEnabled, DocumentSigningEnabled, IsTelecom, RegisterInvoiceeSkipDuplicateCheck, CanEditOrgnrOrCountry, ShowCrossReference, AllowSendSms, ExposeMonths, ClientObjectCodes, ClientCustomerGroups, OmniChannel, UseAccountNo, UsesSubproduct, SetVarselFenix, InvoiceExtraMonthsAhead, HasCardPayment, UsesGuarantor, ShowSubscriptionDescription, DirectInvoice, TelecomEditNumberActive, TelecomUsePortation, UseInvoiceeBatch, IsTriggerBillingInterval, HasAutomaticInvoiceFee, Inbetalningsavi, ReferenceOnInvoice, UseOurReference, PaymentTermsNetDays, UsesPeppol, IsFrozenMonthConfigured, EnableEInvoiceIdentifier, InvoiceSendSMSTemplate, InvoiceSendEmailTemplate, EnableFeesV2, FeeConfig, EmailFromSender, TelecomByteFormat, AllowAddInvoiceeNr, AccountNoCrediting, TelecomNumberDirectoryAlwaysSendEndUserData, TelecomNumberDirectoryConsent, UsesNumberDirectory, UsesContractEndUserTable, UsesConsumptionFees, CurrencyCode, RegisterInvoiceeDefaultInvoiceeType, MortgageR13ShowUpdateBtn, EnableCustomerSpecificCurrencyInvoicing, UsesBoundToDate, ShowInvoiceeFeeTab, EnableTerminationProcess) {
        super();
        this.HasCustomerGroupCode = HasCustomerGroupCode;
        this.UsesSubscriptionObjectCode = UsesSubscriptionObjectCode;
        this.UsesCreditCheck = UsesCreditCheck;
        this.ShowInvoiceeAttributes = ShowInvoiceeAttributes;
        this.ShowContractAttributes = ShowContractAttributes;
        this.ClientInvoiceFees = ClientInvoiceFees;
        this.DefaultInvoiceExclVat = DefaultInvoiceExclVat;
        this.MortgageEnabled = MortgageEnabled;
        this.DocumentSigningEnabled = DocumentSigningEnabled;
        this.IsTelecom = IsTelecom;
        this.RegisterInvoiceeSkipDuplicateCheck = RegisterInvoiceeSkipDuplicateCheck;
        this.CanEditOrgnrOrCountry = CanEditOrgnrOrCountry;
        this.ShowCrossReference = ShowCrossReference;
        this.AllowSendSms = AllowSendSms;
        this.ExposeMonths = (ExposeMonths | 0);
        this.ClientObjectCodes = ClientObjectCodes;
        this.ClientCustomerGroups = ClientCustomerGroups;
        this.OmniChannel = OmniChannel;
        this.UseAccountNo = UseAccountNo;
        this.UsesSubproduct = UsesSubproduct;
        this.SetVarselFenix = SetVarselFenix;
        this.InvoiceExtraMonthsAhead = (InvoiceExtraMonthsAhead | 0);
        this.HasCardPayment = HasCardPayment;
        this.UsesGuarantor = UsesGuarantor;
        this.ShowSubscriptionDescription = ShowSubscriptionDescription;
        this.DirectInvoice = DirectInvoice;
        this.TelecomEditNumberActive = TelecomEditNumberActive;
        this.TelecomUsePortation = TelecomUsePortation;
        this.UseInvoiceeBatch = UseInvoiceeBatch;
        this.IsTriggerBillingInterval = IsTriggerBillingInterval;
        this.HasAutomaticInvoiceFee = HasAutomaticInvoiceFee;
        this.Inbetalningsavi = Inbetalningsavi;
        this.ReferenceOnInvoice = ReferenceOnInvoice;
        this.UseOurReference = UseOurReference;
        this.PaymentTermsNetDays = (PaymentTermsNetDays | 0);
        this.UsesPeppol = UsesPeppol;
        this.IsFrozenMonthConfigured = IsFrozenMonthConfigured;
        this.EnableEInvoiceIdentifier = EnableEInvoiceIdentifier;
        this.InvoiceSendSMSTemplate = InvoiceSendSMSTemplate;
        this.InvoiceSendEmailTemplate = InvoiceSendEmailTemplate;
        this.EnableFeesV2 = EnableFeesV2;
        this.FeeConfig = FeeConfig;
        this.EmailFromSender = EmailFromSender;
        this.TelecomByteFormat = (TelecomByteFormat | 0);
        this.AllowAddInvoiceeNr = AllowAddInvoiceeNr;
        this.AccountNoCrediting = (AccountNoCrediting | 0);
        this.TelecomNumberDirectoryAlwaysSendEndUserData = TelecomNumberDirectoryAlwaysSendEndUserData;
        this.TelecomNumberDirectoryConsent = TelecomNumberDirectoryConsent;
        this.UsesNumberDirectory = UsesNumberDirectory;
        this.UsesContractEndUserTable = UsesContractEndUserTable;
        this.UsesConsumptionFees = UsesConsumptionFees;
        this.CurrencyCode = CurrencyCode;
        this.RegisterInvoiceeDefaultInvoiceeType = RegisterInvoiceeDefaultInvoiceeType;
        this.MortgageR13ShowUpdateBtn = MortgageR13ShowUpdateBtn;
        this.EnableCustomerSpecificCurrencyInvoicing = EnableCustomerSpecificCurrencyInvoicing;
        this.UsesBoundToDate = UsesBoundToDate;
        this.ShowInvoiceeFeeTab = ShowInvoiceeFeeTab;
        this.EnableTerminationProcess = EnableTerminationProcess;
    }
}

export function ClientConfig$reflection() {
    return record_type("Global.ClientConfig", [], ClientConfig, () => [["HasCustomerGroupCode", bool_type], ["UsesSubscriptionObjectCode", bool_type], ["UsesCreditCheck", bool_type], ["ShowInvoiceeAttributes", bool_type], ["ShowContractAttributes", bool_type], ["ClientInvoiceFees", list_type(ClientInvoiceFee$reflection())], ["DefaultInvoiceExclVat", bool_type], ["MortgageEnabled", bool_type], ["DocumentSigningEnabled", bool_type], ["IsTelecom", bool_type], ["RegisterInvoiceeSkipDuplicateCheck", bool_type], ["CanEditOrgnrOrCountry", bool_type], ["ShowCrossReference", bool_type], ["AllowSendSms", bool_type], ["ExposeMonths", int32_type], ["ClientObjectCodes", list_type(ClientObjectCode$reflection())], ["ClientCustomerGroups", list_type(CustomerGroupCode$reflection())], ["OmniChannel", option_type(int32_type)], ["UseAccountNo", bool_type], ["UsesSubproduct", bool_type], ["SetVarselFenix", bool_type], ["InvoiceExtraMonthsAhead", int32_type], ["HasCardPayment", bool_type], ["UsesGuarantor", bool_type], ["ShowSubscriptionDescription", bool_type], ["DirectInvoice", bool_type], ["TelecomEditNumberActive", bool_type], ["TelecomUsePortation", bool_type], ["UseInvoiceeBatch", bool_type], ["IsTriggerBillingInterval", bool_type], ["HasAutomaticInvoiceFee", bool_type], ["Inbetalningsavi", option_type(string_type)], ["ReferenceOnInvoice", bool_type], ["UseOurReference", bool_type], ["PaymentTermsNetDays", int32_type], ["UsesPeppol", bool_type], ["IsFrozenMonthConfigured", bool_type], ["EnableEInvoiceIdentifier", bool_type], ["InvoiceSendSMSTemplate", string_type], ["InvoiceSendEmailTemplate", string_type], ["EnableFeesV2", bool_type], ["FeeConfig", FeeConfig$reflection()], ["EmailFromSender", option_type(string_type)], ["TelecomByteFormat", int32_type], ["AllowAddInvoiceeNr", bool_type], ["AccountNoCrediting", int32_type], ["TelecomNumberDirectoryAlwaysSendEndUserData", bool_type], ["TelecomNumberDirectoryConsent", string_type], ["UsesNumberDirectory", bool_type], ["UsesContractEndUserTable", bool_type], ["UsesConsumptionFees", bool_type], ["CurrencyCode", string_type], ["RegisterInvoiceeDefaultInvoiceeType", string_type], ["MortgageR13ShowUpdateBtn", bool_type], ["EnableCustomerSpecificCurrencyInvoicing", bool_type], ["UsesBoundToDate", bool_type], ["ShowInvoiceeFeeTab", bool_type], ["EnableTerminationProcess", bool_type]]);
}

export class GlobalDependencies extends Record {
    constructor(ClientConfig, ClientNr, RoleInvoiceeNr, ClientName, CountryCode, LanguageCode, CurrentUserName, RequireIdsStepUp, SelectedLanguage, IsAdminUser, Privileges) {
        super();
        this.ClientConfig = ClientConfig;
        this.ClientNr = (ClientNr | 0);
        this.RoleInvoiceeNr = RoleInvoiceeNr;
        this.ClientName = ClientName;
        this.CountryCode = CountryCode;
        this.LanguageCode = LanguageCode;
        this.CurrentUserName = CurrentUserName;
        this.RequireIdsStepUp = RequireIdsStepUp;
        this.SelectedLanguage = SelectedLanguage;
        this.IsAdminUser = IsAdminUser;
        this.Privileges = Privileges;
    }
}

export function GlobalDependencies$reflection() {
    return record_type("Global.GlobalDependencies", [], GlobalDependencies, () => [["ClientConfig", ClientConfig$reflection()], ["ClientNr", int32_type], ["RoleInvoiceeNr", option_type(int32_type)], ["ClientName", string_type], ["CountryCode", IsoCountryCode$reflection()], ["LanguageCode", string_type], ["CurrentUserName", string_type], ["RequireIdsStepUp", bool_type], ["SelectedLanguage", string_type], ["IsAdminUser", bool_type], ["Privileges", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export class LoadState$2 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NotLoaded", "Loading", "Loaded", "LoadFailed"];
    }
}

export function LoadState$2$reflection(gen0, gen1) {
    return union_type("Global.LoadState`2", [gen0, gen1], LoadState$2, () => [[], [], [["Item", gen0]], [["Item", gen1]]]);
}

export function LoadState_map(f, loadState) {
    switch (loadState.tag) {
        case 1: {
            return new LoadState$2(1);
        }
        case 3: {
            return new LoadState$2(3, loadState.fields[0]);
        }
        case 2: {
            return new LoadState$2(2, f(loadState.fields[0]));
        }
        default: {
            return new LoadState$2(0);
        }
    }
}

export function LoadState_defaultValue(value, loadState) {
    switch (loadState.tag) {
        case 1:
        case 3: {
            return value;
        }
        case 2: {
            return loadState.fields[0];
        }
        default: {
            return value;
        }
    }
}

export function LoadState_defaultWith(defThunk, loadState) {
    switch (loadState.tag) {
        case 1:
        case 3: {
            return defThunk();
        }
        case 2: {
            return loadState.fields[0];
        }
        default: {
            return defThunk();
        }
    }
}

export function LoadState_zip(ls1, ls2) {
    const matchValue = [ls1, ls2];
    let pattern_matching_result, b, a, b_1;
    if (matchValue[0].tag === 1) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else if (matchValue[0].tag === 2) {
        if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 2) {
            pattern_matching_result = 2;
            a = matchValue[0].fields[0];
            b_1 = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
    }
    else if (matchValue[0].tag === 0) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 3;
        }
    }
    else {
        pattern_matching_result = 0;
        b = matchValue[0].fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            return new LoadState$2(3, b);
        }
        case 1: {
            return new LoadState$2(1);
        }
        case 2: {
            return new LoadState$2(2, [a, b_1]);
        }
        case 3: {
            return new LoadState$2(0);
        }
    }
}

export function LoadState_zip3(ls1, ls2, ls3) {
    const matchValue = [ls1, ls2, ls3];
    let pattern_matching_result, b, a, b_1, c;
    if (matchValue[0].tag === 1) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[2].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[2].fields[0];
        }
        else if (matchValue[2].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[2].tag === 0) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else if (matchValue[0].tag === 2) {
        if (matchValue[1].tag === 1) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[1].tag === 2) {
            if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 2) {
                pattern_matching_result = 2;
                a = matchValue[0].fields[0];
                b_1 = matchValue[1].fields[0];
                c = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
    }
    else if (matchValue[0].tag === 0) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (matchValue[2].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[2].fields[0];
        }
        else if (matchValue[2].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[2].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 3;
        }
    }
    else {
        pattern_matching_result = 0;
        b = matchValue[0].fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            return new LoadState$2(3, b);
        }
        case 1: {
            return new LoadState$2(1);
        }
        case 2: {
            return new LoadState$2(2, [a, b_1, c]);
        }
        case 3: {
            return new LoadState$2(0);
        }
    }
}

export function LoadState_zip4(ls1, ls2, ls3, ls4) {
    const matchValue = [ls1, ls2, ls3, ls4];
    let pattern_matching_result, b, a, b_1, c, d;
    if (matchValue[0].tag === 1) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[2].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[2].fields[0];
        }
        else if (matchValue[2].tag === 1) {
            if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[2].tag === 0) {
            if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[3].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[3].fields[0];
        }
        else if (matchValue[3].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[3].tag === 0) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else if (matchValue[0].tag === 2) {
        if (matchValue[1].tag === 1) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[1].tag === 2) {
            if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 2) {
                if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 2) {
                    pattern_matching_result = 2;
                    a = matchValue[0].fields[0];
                    b_1 = matchValue[1].fields[0];
                    c = matchValue[2].fields[0];
                    d = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 3;
                }
                else {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 3;
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 3;
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
    }
    else if (matchValue[0].tag === 0) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[1].tag === 0) {
            if (matchValue[2].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[2].fields[0];
            }
            else if (matchValue[2].tag === 1) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else if (matchValue[2].tag === 0) {
                if (matchValue[3].tag === 3) {
                    pattern_matching_result = 0;
                    b = matchValue[3].fields[0];
                }
                else if (matchValue[3].tag === 1) {
                    pattern_matching_result = 1;
                }
                else if (matchValue[3].tag === 0) {
                    pattern_matching_result = 3;
                }
                else {
                    pattern_matching_result = 3;
                }
            }
            else if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (matchValue[2].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[2].fields[0];
        }
        else if (matchValue[2].tag === 1) {
            if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else if (matchValue[2].tag === 0) {
            if (matchValue[3].tag === 3) {
                pattern_matching_result = 0;
                b = matchValue[3].fields[0];
            }
            else if (matchValue[3].tag === 1) {
                pattern_matching_result = 1;
            }
            else if (matchValue[3].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if (matchValue[3].tag === 3) {
            pattern_matching_result = 0;
            b = matchValue[3].fields[0];
        }
        else if (matchValue[3].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[3].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 3;
        }
    }
    else {
        pattern_matching_result = 0;
        b = matchValue[0].fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            return new LoadState$2(3, b);
        }
        case 1: {
            return new LoadState$2(1);
        }
        case 2: {
            return new LoadState$2(2, [a, b_1, c, d]);
        }
        case 3: {
            return new LoadState$2(0);
        }
    }
}

export class SaveStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NotSaving", "Saving", "Saved", "SaveFailed"];
    }
}

export function SaveStatus$reflection() {
    return union_type("Global.SaveStatus", [], SaveStatus, () => [[], [], [], [["Item", string_type]]]);
}

export function SaveStatus_CoalesceSaveStates(s1, s2) {
    const matchValue = [s1, s2];
    let pattern_matching_result, msg;
    if (matchValue[0].tag === 1) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            msg = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else if (matchValue[0].tag === 2) {
        if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 2) {
            pattern_matching_result = 2;
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 0;
            msg = matchValue[1].fields[0];
        }
    }
    else if (matchValue[0].tag === 0) {
        if (matchValue[1].tag === 3) {
            pattern_matching_result = 0;
            msg = matchValue[1].fields[0];
        }
        else if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 3;
        }
    }
    else {
        pattern_matching_result = 0;
        msg = matchValue[0].fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            return new SaveStatus(3, msg);
        }
        case 1: {
            return new SaveStatus(1);
        }
        case 2: {
            return new SaveStatus(2);
        }
        case 3: {
            return new SaveStatus(0);
        }
    }
}

export function SaveStatus_OfLoadState_3AB583F7(ls) {
    switch (ls.tag) {
        case 1: {
            return new SaveStatus(1);
        }
        case 3: {
            return new SaveStatus(3, ls.fields[0]);
        }
        case 2: {
            return new SaveStatus(2);
        }
        default: {
            return new SaveStatus(0);
        }
    }
}

export function $007CPrefix$007C_$007C(p, s) {
    if (s.indexOf(p) === 0) {
        return substring(s, p.length);
    }
    else {
        return void 0;
    }
}

export function $007CPostfix$007C_$007C(p, s) {
    if (endsWith(s, p)) {
        return substring(s, 0, s.length - p.length);
    }
    else {
        return void 0;
    }
}

export function Flatpickr_OnChangeOption(callback) {
    return custom("onChange", (dates) => {
        callback(((dates == null) ? true : (dates.length === 0)) ? (void 0) : head(dates));
    }, false);
}

export function loadEffect(loadFn, updateFn) {
    updateFn(new LoadState$2(1));
    startImmediate(singleton.Delay(() => singleton.Bind(loadFn(), (_arg) => {
        const result = _arg;
        updateFn((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0])));
        return singleton.Zero();
    })));
}

export function saveEffect(loadFn, updateFn) {
    updateFn(new SaveStatus(1));
    startImmediate(singleton.Delay(() => singleton.Bind(loadFn(), (_arg) => {
        const result = _arg;
        updateFn((result.tag === 1) ? (new SaveStatus(3, result.fields[0])) : (new SaveStatus(2)));
        return singleton.Zero();
    })));
}

export function getEffectDispose(cleanUpFn) {
    return {
        Dispose() {
            cleanUpFn();
        },
    };
}

function notFoundResponse(key) {
    return ("%% " + key) + " %%";
}

export function getTranslationFrom(translations, key) {
    if (translations.tag === 2) {
        return defaultArgWith(map((value) => {
            if (value.tag === 1) {
                return value.fields[0];
            }
            else {
                return notFoundResponse(key);
            }
        }, tryFind(key, translations.fields[0])), () => notFoundResponse(key));
    }
    else {
        return notFoundResponse(key);
    }
}

